import { ApolloError, gql, useMutation } from "@apollo/client";
import { UserRole, WorkerType } from "../generated/graphql";

export interface EditStaffUserInput {
  userId: number;
  name?: string | null;
  phone?: string | null;
  role?: UserRole | null;
  workerType?: WorkerType | null;
  linkServiceIds?: number[] | null;
  password?: string | null;
}

export interface EditStaffUserOutput {
  ok: boolean;
  err?: string | null;
}

export interface EditStaffUserMutation {
  editStaffUser: EditStaffUserOutput;
}

export interface EditStaffUserMutationVariables {
  input: EditStaffUserInput;
}

const EDIT_STAFF_USER_MUTATION = gql`
  mutation editStaffUser($input: EditStaffUserInput!) {
    editStaffUser(input: $input) {
      ok
      err
    }
  }
`;

export const useEditStaffUser = (
  onCompleted?: (data: EditStaffUserMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<EditStaffUserMutation, EditStaffUserMutationVariables>(
    EDIT_STAFF_USER_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
